export default function generate(Service) {
  const state = {
    roles: []
  };
  const getters = {
    getRoles(state) {
      return state.roles;
    }
  };
  const actions = {
    getRoles({ commit }) {
      return Service.getRoles(roles => {
        commit("setRoles", {
          roles
        });
      });
    }
  };
  const mutations = {
    setRoles(state, { roles }) {
      state.roles = roles;
    }
  };
  return {
    state,
    getters,
    actions,
    mutations
  };
}
